export default "__VITE_ASSET__D47Td0E5__"